import { format, parseISO, isToday, isYesterday, formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';

export function fmtDate(date?: string | null, withTime = false): string {
  if (!date) return '';
  try {
    const d = parseISO(date);
    return format(d, withTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy');
  } catch { return ''; }
}

// Hora corta HH:mm (para items dentro de un grupo de día ya etiquetado).
export function fmtTime(date?: string | null): string {
  if (!date) return '';
  try { return format(parseISO(date), 'HH:mm'); } catch { return ''; }
}

// Etiqueta de grupo por día: "Hoy" / "Ayer" / "dd/MM/yyyy".
export function dayGroupLabel(date?: string | null): string {
  if (!date) return '';
  try {
    const d = parseISO(date);
    if (isToday(d)) return 'Hoy';
    if (isYesterday(d)) return 'Ayer';
    return format(d, "d 'de' MMMM yyyy", { locale: es });
  } catch { return ''; }
}

// Tiempo relativo en español ("hace 5 minutos", "hace 2 horas"). Para items
// de hoy se lee más natural que la hora absoluta.
export function relativeTime(date?: string | null): string {
  if (!date) return '';
  try {
    return formatDistanceToNow(parseISO(date), { addSuffix: true, locale: es });
  } catch { return ''; }
}

export function isLightColor(hex: string): boolean {
  const c = hex.replace('#', '');
  if (c.length !== 6) return true;
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6;
}

export function contrastingText(hex: string): string {
  return isLightColor(hex) ? '#1c1917' : '#ffffff';
}

export function lighten(hex: string, amount = 0.85): string {
  const c = hex.replace('#', '');
  if (c.length !== 6) return hex;
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  const blend = (v: number) => Math.round(v + (255 - v) * amount);
  const toHex = (v: number) => v.toString(16).padStart(2, '0');
  return `#${toHex(blend(r))}${toHex(blend(g))}${toHex(blend(b))}`;
}

export function initials(name?: string | null): string {
  if (!name) return '?';
  return name.trim().split(/\s+/).map(p => p[0]).slice(0, 2).join('').toUpperCase();
}
